import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../../assets/icons";
import useRequest from "../../components/hooks/use-request";
import { formatCurrency } from "../../utilities/functions";
import { TailSpin } from "react-loader-spinner";

const avatarColors = ["#0979A1", "#E85D04", "#7B2D8B", "#2D6A4F", "#D62828", "#023E8A", "#B5179E"];
const avatarColor = (name: string) => avatarColors[(name?.charCodeAt(0) || 0) % avatarColors.length];

const UserAvatar = ({ name }: { name: string }) => (
  <div
    className="w-8 h-8 rounded-full flex items-center justify-center text-white text-[12px] font-semibold shrink-0"
    style={{ backgroundColor: avatarColor(name) }}>
    {name?.charAt(0).toUpperCase()}
  </div>
);

const RankBadge = ({ rank }: { rank: number }) => {
  if (rank === 1) return <Icon name="goldMedal" />;
  if (rank === 2) return <Icon name="silverMedal" />;
  if (rank === 3) return <Icon name="bronzeMedal" />;
  return <span className="text-[14px] font-semibold text-gray-600">{rank}</span>;
};

const TopAssociates = () => {
  const userToken = localStorage.getItem("token");
  const [associates, setAssociates] = useState<any[]>([]);

  const { makeRequest, loading } = useRequest("/marketers/leaderboard", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

  useEffect(() => {
    const fetch = async () => {
      const [res] = await makeRequest();
      if (res?.data) setAssociates(res.data || []);
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="w-[95%]">
        <p className="text-[13px] text-gray-500 mb-1">
          <Link to="/referral-program" className="text-[#0979A1] font-medium">Overview</Link>
          {" / Top Sales Associates"}
        </p>
        <h2 className="text-[24px] font-bold mb-5">Top Sales Associates</h2>

        <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 max-w-lg">
          <h3 className="text-[16px] font-semibold">Sale Associates Ranking</h3>
          <p className="text-[13px] text-gray-500 mb-5">
            Ranking is based on the number and value of transactions carried out by referred users.
          </p>

          {/* Table header */}
          <div className="grid grid-cols-12 text-[12px] text-gray-500 font-medium pb-3 border-b gap-2">
            <span className="col-span-2">Rank</span>
            <span className="col-span-5">Associate</span>
            <span className="col-span-2 text-right">Transactions</span>
            <span className="col-span-3 text-right">Value</span>
          </div>

          {loading ? (
            <div className="flex justify-center items-center h-64">
              <TailSpin color="skyblue" />
            </div>
          ) : associates.map((a: any, i: number) => (
            <div key={i} className="grid grid-cols-12 text-[13px] py-3 border-b border-gray-50 items-center gap-2">
              <div className="col-span-2 flex items-center">
                <RankBadge rank={i + 1} />
              </div>
              <div className="col-span-5 flex items-center gap-2">
                <UserAvatar name={a.name || ""} />
                <span className="font-medium">{a.name}</span>
              </div>
              <span className="col-span-2 text-right">{(a.numberOfTransactions || 0).toLocaleString()}</span>
              <span className="col-span-3 text-right font-medium">{formatCurrency(a.totalTransactionValue || 0, "NGN", "symbol")}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TopAssociates;
